import { STATUS } from '@features/General'
import { MeetingType, MeetingStatus } from '@features/Meeting/MeetingAgenda'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IAddMeetingPayload {
    data: {
        status: keyof typeof MeetingStatus
        meetingType: keyof typeof MeetingType
        hostIds: string[]
        guestIds: string[]
        hostCompanyId: string
        guestCompanyId: string
        description: string
        guests: string[]
        table: string
        hall: string
        floorPlanLink: string
        meetingDuration: number
        reminderDuration: number
        startTime: string
        endTime: string
        reminderType: string[]
    }
    sagaCB?: {
        onSuccess: any
    }
}

export interface IAddMeetingState {
    status: string
    data: any
    errors: any
}

const initialState: IAddMeetingState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const addMeeting = createSlice({
    name: 'meeting/add',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IAddMeetingPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const addMeetingActions = addMeeting.actions
export default addMeeting.reducer
